export default "__VITE_ASSET__B$LOjmVa__"